import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

const AddNewCreditCardIcon = (props: IBaseProps) => (
  <svg
    width="34"
    height="24"
    viewBox="0 0 34 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" fill="white" stroke="#502314" />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 6H34V12H0V6Z" fill="#502314" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.66667 16.25C5.66667 15.4676 6.30094 14.8333 7.08334 14.8333H11.3333C12.1157 14.8333 12.75 15.4676 12.75 16.25C12.75 17.0324 12.1157 17.6667 11.3333 17.6667H7.08334C6.30094 17.6667 5.66667 17.0324 5.66667 16.25Z"
      fill="#502314"
    />
  </svg>
);

export default AddNewCreditCardIcon;
